import { GET_CRM_DATA } from "../ActionTypes/ActionTypes";

import CRMService from "../Services/CRMService";

export const getCRMDataDetails = (opportunityId) => async (dispatch) => {
    try {
        const res = await CRMService.getCRMOpportunity(opportunityId);

        dispatch({
            type: GET_CRM_DATA,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getCrmUploadData = (quoteId) => async (dispatch) => {
    try {
        const res = await CRMService.getCrmUploadData(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getCrmDataSync = async (dispatch) => {
    try {
        const res = await CRMService.getCrmDataSync();
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getQuoteDetailsFromCrm = (oppotunityId) => async (dispatch) => {
    try {
        const res = await CRMService.getQuoteDetailsFromCrm(oppotunityId);
        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const getCrmPopulationUploadData = (quoteId) => async (dispatch) => {
    try {
        const res = await CRMService.getCrmPopulationUploadData(quoteId);

        return Promise.resolve(res.data);
    } catch (err) {
        console.log(err);
    }
};

export const addOpportunityProduct = (opportunityProduct) => async (dispatch) => {
        try {
            const res = await CRMService.addOpportunityProduct(opportunityProduct);

            return Promise.resolve(res.data);
        } catch (err) {
            console.log(err);
        }
};

export const addCountryHeadcount = (cpqCountryHCRequestModell) => async (dispatch) => {
    try {
        const res = await CRMService.addCountryHeadcount(cpqCountryHCRequestModell);

            return Promise.resolve(res.data);
        } catch (err) {
            console.log(err);
        }
};

export const addBundledProduct = (bundleObject) => async (dispatch) => {
    try {
        const res = await CRMService.addBundledProduct(bundleObject);

            return Promise.resolve(res.data);
        } catch (err) {
            console.log(err);
        }
};
